// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1EEfu","title":"AfterBackImages_title__35zDS","images":"AfterBackImages_images__2lvXL"};